.link {
  white-space: nowrap;
  align-content: center;
  color: var(--colors-text-main);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-end;
  width: 80px;
}

.link--selected {
  font-weight: 600;
}

.icon--brand-specials-selected div {
  background-color: var(--colors-brand-gold-light);
}
